import i18n from "../../../plugins/i18n.js";
import router from "../../../router";
import store from "../../../store";
import {
  readFromLocalStorage,
  saveToLocalStorage,
} from "./localStorageHandler";

export const setLanguage = (locale, forceReRoute) => {
  if (forceReRoute == null) forceReRoute = true;

  i18n.locale = locale;
  store.commit("UPDATE_RTL", locale === "ar");

  if (forceReRoute) {
    router.push({
      params: { lang: locale },
    });
  }

  return locale;
};

export const getSavedLanguage = () => {
  return readFromLocalStorage("Language");
};

export const saveLanguage = value => {
  saveToLocalStorage("Language", value);
};

export const customLocalisedAutoCompleteFilter = (item, queryText) => {
  const searchText = queryText.toLowerCase();
  let sourceText;

  if (typeof item === "object") {
    sourceText = item.name ?? item.title;
  } else if (typeof item === "string") {
    sourceText = item;
  }

  if (sourceText) {
    if (sourceText instanceof Array) {
      return (
        sourceText?.findIndex(
          x => x.value?.toLowerCase()?.indexOf(searchText) > -1
        ) > -1
      );
    } else if (typeof sourceText === "string") {
      return sourceText?.toLowerCase()?.indexOf(searchText) > -1;
    }
  }

  return false;
};
